import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=6bdafb8b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Employee.vue"
export default component.exports